var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-bodyNav",class:"bodyNavStyle" + _vm.subSite},[_c('navList',{attrs:{"page":_vm.subSite}}),_c('resAndTools'),_c('brandingNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }